import {Center, Spinner} from '@chakra-ui/react'

const Loading = () => {
  return (
    <Center
      position={'absolute'}
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={2000}
      bg={'rgba(255,255,255,0.7)'}>
      <Spinner color="#0050B3" />
    </Center>
  )
}

export default Loading
